import React, { useState } from 'react';

const Contact = ({ data }) => {
  const [name, setName] = useState('');
  const [subject, setSubject] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (data?.email) {
      const mailtoLink = `mailto:${data.email}?subject=${encodeURIComponent(
        subject
      )}&body=${encodeURIComponent(
        `From: ${name} (${email})\n\n${message}`
      )}`;
      window.open(mailtoLink);
    }
  };

  if (!data) return null;

  return (
    <section id="contact">
      <div className="container">
        <h1>Get In Touch</h1>
        <p className="lead">
          {data.contactmessage ||
            "Let's connect and discuss how we can work together."}
        </p>

        <div className="contact-wrapper-grid">
          {/* Availability Status */}
          <div className="availability-status">
            <span className="status-indicator"></span>
            <p>Available for freelance opportunities</p>
          </div>

          {/* Contact Information */}
          <div className="contact-info-section">
            <div className="contact-methods">
              <div className="contact-method">
                <div className="contact-method-icon">
                  <i className="fa fa-envelope"></i>
                </div>
                <div className="contact-method-content">
                  <h4>Email</h4>
                  <a href={`mailto:${data.email}`}>{data.email}</a>
                </div>
              </div>

              <div className="contact-method">
                <div className="contact-method-icon">
                  <i className="fa fa-phone"></i>
                </div>
                <div className="contact-method-content">
                  <h4>Phone</h4>
                  <a href={`tel:${data.phone}`}>{data.phone}</a>
                </div>
              </div>

              <div className="contact-method">
                <div className="contact-method-icon">
                  <i className="fa fa-map-marker"></i>
                </div>
                <div className="contact-method-content">
                  <h4>Location</h4>
                  <p>{data.address.city}, {data.address.state}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="contact-form-wrapper">
            <h3>Send a Message</h3>
            <p className="subtitle">
              Have a project in mind? Let's discuss how I can help you achieve your goals.
            </p>
            <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Full Name *</label>
              <input
                id="name"
                type="text"
                placeholder="John Doe"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email Address *</label>
              <input
                id="email"
                type="email"
                placeholder="john@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="subject">Subject</label>
              <input
                id="subject"
                type="text"
                placeholder="How can I help you?"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">Message *</label>
              <textarea
                id="message"
                placeholder="Tell me about your project..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
                rows="6"
              ></textarea>
            </div>

            <button type="submit" className="button">
              <i className="fa fa-paper-plane"></i> Send Message
            </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
